<div class="prompt-list-wrapper">
  <!-- Toolbar with Search, Filters, and Create Button -->
  <div class="toolbar dense-2">
    <div class="filter-group">
      <!-- Category Filter -->
      <mat-form-field
        appearance="outline"
        class="filter-dropdown compact-field"
        subscriptSizing="dynamic"
      >
        <mat-label>Filter by Category</mat-label>
        <mat-select
          [(value)]="selectedCategory"
          (selectionChange)="applyCategoryFilter($event.value)"
        >
          <mat-option value="">All Categories</mat-option>
          <mat-option *ngFor="let category of categories" [value]="category">{{
            category
          }}</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Tag Filter -->
      <mat-form-field
        appearance="outline"
        class="filter-dropdown compact-field"
        subscriptSizing="dynamic"
      >
        <mat-label>Filter by Tag</mat-label>
        <mat-select
          [(value)]="selectedTag"
          (selectionChange)="applyTagFilter($event.value)"
          multiple
        >
          <mat-option *ngFor="let tag of tags" [value]="tag">{{
            tag
          }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Search Bar -->
    <mat-form-field
      appearance="outline"
      class="search-field compact-field"
      subscriptSizing="dynamic"
    >
      <mat-label>Search Prompts</mat-label>
      <input
        matInput
        (keyup)="applyFilter()"
        placeholder="Search by name, category, or tags"
      />
      <button mat-icon-button matSuffix disabled>
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>

    <!-- Create Prompt Button -->
    <button mat-flat-button color="primary" (click)="createPrompt()">
      <mat-icon>add</mat-icon> New Prompt
    </button>
  </div>

  <!-- Prompt Table -->
  <div class="table-container">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
      <!-- Selection Checkbox Column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="toggleSelectAll($event)"></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let prompt">
          <mat-checkbox [(ngModel)]="prompt.selected"></mat-checkbox>
        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td mat-cell *matCellDef="let prompt">{{ prompt.name }}</td>
      </ng-container>

      <!-- Category Column -->
      <ng-container matColumnDef="category">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Category</th>
        <td mat-cell *matCellDef="let prompt">{{ prompt.category }}</td>
      </ng-container>

      <!-- Tags Column -->
      <ng-container matColumnDef="tags">
        <th mat-header-cell *matHeaderCellDef>Tags</th>
        <td mat-cell *matCellDef="let prompt">
          <mat-chip-listbox>
            <mat-chip *ngFor="let tag of prompt.tags" color="accent" selected>
              {{ tag }}
            </mat-chip>
          </mat-chip-listbox>
        </td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let prompt">
          <mat-slide-toggle
            [checked]="prompt.is_active"
            (change)="toggleActivation(prompt)"
          >
            {{ prompt.is_active ? 'Active' : 'Inactive' }}
          </mat-slide-toggle>
        </td>
      </ng-container>

      <!-- Permission Type Column -->
      <ng-container matColumnDef="permission_type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Permission</th>
        <td mat-cell *matCellDef="let prompt">
          {{ prompt.permission_type | titlecase }}
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let prompt">
          <button
            mat-icon-button
            color="accent"
            (click)="viewPrompt(prompt)"
            matTooltip="View"
          >
            <mat-icon>visibility</mat-icon>
          </button>
          <button
            mat-icon-button
            color="primary"
            (click)="editPrompt(prompt)"
            matTooltip="Edit"
          >
            <mat-icon>edit</mat-icon>
          </button>
          <button
            mat-icon-button
            color="warn"
            (click)="deletePrompt(prompt.prompt_id)"
            matTooltip="Delete"
          >
            <mat-icon>delete</mat-icon>
          </button>
          <button
            mat-icon-button
            color="primary"
            (click)="duplicatePrompt(prompt)"
            matTooltip="Duplicate"
          >
            <mat-icon>content_copy</mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- Header and Row Declarations -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <!-- Pagination -->
  <mat-paginator
    [pageSizeOptions]="[5, 10, 20]"
    showFirstLastButtons
  ></mat-paginator>
</div>
